(() => {
  if (window.memeifyCustomRequestReady) return;
  window.memeifyCustomRequestReady = true;

  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-memeify-dialog-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.memeifyDialogOpen));
      return;
    }

    const closer = event.target.closest('[data-memeify-dialog-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }

    const copyButton = event.target.closest('[data-memeify-copy-email]');
    if (copyButton) {
      const dialog = copyButton.closest('dialog');
      const status = dialog ? dialog.querySelector('[data-memeify-copy-status]') : null;

      try {
        await copyText(copyButton.dataset.memeifyCopyEmail);
        copyButton.textContent = 'Copied';
        if (status) status.textContent = 'Email address copied.';
      } catch (error) {
        copyButton.textContent = 'Copy failed';
        if (status) status.textContent = 'Copy failed. Select the email address manually.';
      }

      window.setTimeout(() => {
        copyButton.textContent = 'Copy email';
        if (status) status.textContent = '';
      }, 2500);
    }
  });

  document.addEventListener('click', (event) => {
    if (
      typeof HTMLDialogElement !== 'undefined' &&
      event.target instanceof HTMLDialogElement &&
      event.target.open
    ) {
      const bounds = event.target.getBoundingClientRect();
      const inside =
        event.clientX >= bounds.left &&
        event.clientX <= bounds.right &&
        event.clientY >= bounds.top &&
        event.clientY <= bounds.bottom;

      if (!inside) closeDialog(event.target);
    }
  });
})();
